import { StyleSheet, View } from "react-native";
import { Text } from "react-native-paper";

import { evidenceLines, evidenceSpans } from "@/lib/context-evidence-format";
import { colors, fonts, spacing } from "@/lib/theme";

/** Small, native renderer for the formatting used in document transcriptions. */
export function DocumentEvidenceText({ text }: { text: string }) {
    return (
        <View style={styles.body}>
            {evidenceLines(text).map((line, index) => (
                <View key={index} style={line.kind === "row" ? styles.row : styles.line}>
                    {line.kind === "bullet" ? <Text style={styles.text}>•</Text> : null}
                    {line.cells.map((cell, cellIndex) => (
                        <Text
                            key={cellIndex}
                            selectable
                            style={[
                                styles.text,
                                styles.cell,
                                line.kind === "heading" && styles.heading,
                                line.kind === "row" && styles.tableCell
                            ]}
                        >
                            {evidenceSpans(cell).map((span, spanIndex) => (
                                <Text
                                    key={spanIndex}
                                    style={span.emphasis ? styles.emphasis : undefined}
                                >
                                    {span.text}
                                </Text>
                            ))}
                        </Text>
                    ))}
                </View>
            ))}
        </View>
    );
}

const styles = StyleSheet.create({
    body: { gap: spacing.sm },
    line: { flexDirection: "row", gap: 8 },
    row: {
        flexDirection: "row",
        flexWrap: "wrap",
        gap: 8,
        borderBottomWidth: StyleSheet.hairlineWidth,
        borderBottomColor: colors.textSecondary,
        paddingBottom: 8
    },
    text: { fontFamily: fonts.regular, fontSize: 14, lineHeight: 21, color: colors.textPrimary },
    cell: { flexShrink: 1 },
    tableCell: { flexGrow: 1, flexBasis: 100 },
    heading: { fontFamily: fonts.semiBold, marginTop: 4 },
    emphasis: { fontFamily: fonts.semiBold }
});
